<template>
  <section class="section">
    <form @submit.prevent="validateBeforeSubmit">
      <div class="container">
        <div class="columns">
          <div class="column is-11">
            <h1 class="title green">
              {{ $translate(this.title) | capitalize }}
              <span style="float:right">
                {{ $translate("order") | capitalize }} :
                {{ this.order.primaryCode }}
              </span>
            </h1>
          </div>

          <div class="column has-text-right">
            <b-field grouped>
              <b-field>
                <b-button
                  type="is-primary"
                  icon-right="content-save-outline"
                  :disabled="isBlocked()"
                  @click="saveResponse('responseSaved')"
                />
              </b-field>
              <b-field>
                <b-button
                  type="is-primary"
                  icon-right="send-outline"
                  :disabled="
                isBlocked() ||
                  ($store.getters.user.userInfo.type == 'C' &&
                    $store.getters.user.userInfo.level == '1')
              "
                  @click="saveResponse('responseSent')"
                />
              </b-field>
            </b-field>
          </div>
        </div>
        <div class="container">
          <div class="columns">
            <div class="column"></div>
            <div class="column">
              <p>{{ $translate("patient") | capitalize }}</p>
            </div>
            <div class="column">
              <strong v-if="this.order.patient != null">
                {{ this.order.patient.name }}
                {{ this.order.patient.surname }}
              </strong>
            </div>

            <div class="column">
              <p>{{ $translate("orderType") }}</p>
            </div>
            <div class="column">
              <strong>{{ $translate(order.orderType) | capitalize }}</strong>
            </div>
            <div class="column"></div>
          </div>
          <div class="columns">
            <div class="column"></div>
            <div class="column">
              <p>{{ $translate("rif_ordine") }}</p>
            </div>
            <div class="column">
              <strong>{{ order.primaryCode }}</strong>
            </div>

            <div class="column">
              <p>{{ $translate("deliveryType") }}</p>
            </div>
            <div class="column">
              <strong>
                {{
                $translate(order.deliverySelected) | capitalize
                }}
              </strong>
            </div>
            <div class="column"></div>
          </div>
          <div class="columns">
            <div class="column"></div>
            <div class="column">
              <p>{{ $translate("creator") }}</p>
            </div>
            <div class="column">
              <strong>{{ order.tec }}</strong>
            </div>

            <div class="column">
              <p>{{ $translate("date_in") }}</p>
            </div>
            <div class="column">
              <strong>
                {{ new Date(order.creationDate).toLocaleDateString() }} -
                {{
                new Date(order.lastModificationDate).toLocaleDateString()
                }}
              </strong>
            </div>
            <div class="column"></div>
          </div>

          <div class="columns">
            <div class="column"></div>
            <div class="column">
              <p>{{ $translate("claim_by") }}</p>
            </div>
            <div class="column">
              <strong>{{ claim.tec }}</strong>
            </div>

            <div class="column">
              <p>{{ $translate("date_in") }}</p>
            </div>
            <div class="column">
              <strong>
                {{ new Date(claim.creationDate).toLocaleDateString() }} -
                {{
                new Date(claim.lastModificationDate).toLocaleDateString()
                }}
              </strong>
            </div>
            <div class="column"></div>
          </div>
          <hr class="green" />
          <h3
            class="subtitle green has-text-centered"
          >{{ $translate("description_title_response_claim") }}</h3>

          <template v-if="claim.generalInfo">
            <b-field horizontal>
              <strong>{{ claim.generalInfotext }}</strong>
            </b-field>

            <b-field
              :type="{ 'is-danger': errors.has('generalInfotext') }"
              :message="errors.first('generalInfotext')"
              :label="$translate('generalInfotext')"
              horizontal
            >
              <b-input
                name="generalInfotext"
                type="textarea"
                v-model="claim.generalInfoanswer"
                v-validate="'required'"
                :disabled="isBlocked()"
              ></b-input>
            </b-field>
          </template>

          <template v-if="claim.orderType">
            <b-field horizontal>
              <strong>{{ claim.orderTypetext }}</strong>
            </b-field>

            <b-field
              :type="{ 'is-danger': errors.has('orderTypetext') }"
              :message="errors.first('orderTypetext')"
              :label="$translate('orderTypetext')"
              horizontal
            >
              <b-input
                name="orderTypetext"
                type="textarea"
                v-model="claim.orderTypeanswer"
                v-validate="'required'"
                :disabled="isBlocked()"
              ></b-input>
            </b-field>
          </template>
          <template v-if="claim.model">
            <b-field horizontal>
              <strong>{{ claim.modeltext }}</strong>
            </b-field>

            <b-field
              :type="{ 'is-danger': errors.has('modeltext') }"
              :message="errors.first('modeltext')"
              :label="$translate('modeltext') | capitalize"
              horizontal
            >
              <b-input
                name="modeltext"
                type="textarea"
                v-model="claim.modelanswer"
                v-validate="'required'"
                :disabled="isBlocked()"
              ></b-input>
            </b-field>
          </template>

          <template v-if="claim.footmeasurements">
            <b-field horizontal>
              <strong>{{ claim.footmeasurementstext }}</strong>
            </b-field>

            <b-field
              :type="{ 'is-danger': errors.has('footmeasurementstext') }"
              :message="errors.first('footmeasurementstext')"
              :label="$translate('footmeasurementstext')"
              horizontal
            >
              <b-input
                name="footmeasurementstext"
                type="textarea"
                v-model="claim.footmeasurementsanswer"
                v-validate="'required'"
                :disabled="isBlocked()"
              ></b-input>
            </b-field>
          </template>
          <template v-if="claim.prod_details">
            <b-field horizontal>
              <strong>{{ claim.prod_detailstext }}</strong>
            </b-field>

            <b-field
              :type="{ 'is-danger': errors.has('prod_detailstext') }"
              :message="errors.first('prod_detailstext')"
              :label="$translate('prod_detailstext')"
              horizontal
            >
              <b-input
                name="prod_detailstext"
                type="textarea"
                v-model="claim.prod_detailsanswer"
                v-validate="'required'"
                :disabled="isBlocked()"
              ></b-input>
            </b-field>
          </template>
          <b-field v-if="claim.attachbool" :label="$translate('file') | capitalize" horizontal>
            <a target="_blank" v-bind:href="claim.attach">
              <b-button>{{ $translate("link_to_file") | capitalize }}</b-button>
            </a>
          </b-field>

          <b-field
            horizontal
            v-if="claim.attachboolanswer"
            class="file"
            :label="$translate('file_answer') | capitalize"
          >
            <a target="_blank" v-bind:href="claim.attachanswer">
              <b-button>{{ $translate("link_to_file") | capitalize }}</b-button>
            </a>

            <b-button @click="removefile" :disabled="isBlocked()">
              {{
              $translate("remove_file") | capitalize
              }}
            </b-button>
          </b-field>
          <b-field
            class="file"
            :label="$translate('file_answer') | capitalize"
            :message="errors.first('file_answer')"
            :type="{ 'is-danger': errors.has('file_answer') }"
            horizontal
            v-else
          >
            <b-upload
              v-model="claim.attachanswer"
              name="file_answer"
              :disabled="isBlocked()"
              accept="image/*, application/pdf"
            >
              <a class="button is-primary">
                <b-icon icon="upload"></b-icon>
                <span>{{ $translate("upload_button") }}</span>
              </a>
              <span class="file-name" v-if="claim.attachanswer">{{ claim.attachanswer.name }}</span>
            </b-upload>
          </b-field>
        </div>
      </div>
    </form>

    <b-loading :is-full-page="true" :active.sync="isSaveDisabled" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  name: "ResponseForm",
  components: {},
  data() {
    return {
      isSaveDisabled: false,
      attachtoremove: false,
      claim: {},
      order: {},
      orderid: null,
      claimid: null,
      id: null
    };
  },
  watch: {},
  methods: {
    isBlocked() {
      return !(
        this.claim.status == "sent" || this.claim.status == "responseSaved"
      );
    },
    removefile() {
      this.claim.attachboolanswer = false;
      this.claim.attachanswer = null;
      this.attachtoremove = true;
    },
    async saveResponse(newStatus) {
      this.isSaveDisabled = true;
      this.$validator.validateAll().then(async result => {
        if (result) {
          this.claim.answertec = this.$store.getters.user.userInfo.username;
          this.claim.answercreationDate = new Date().getTime();
          this.claim.status = newStatus;
          this.claim.answer = this.claim.status == "responseSent";

          if (this.attachtoremove) {
            var desertRef = this.$storage.ref(
              "order/attachment/" +
                this.order.id +
                "/claimanswer/" +
                this.claimid
            );
            await desertRef.delete().then(function() {});
          }
          const storageRef = this.$storage.ref(
            "order/attachment/" + this.order.id + "/claimanswer/" + this.claimid
          );
          if (this.claim.attachanswer && this.claim.attachanswer.name) {
            await storageRef
              .put(this.claim.attachanswer)
              .then(async snapshot => {
                await snapshot.ref.getDownloadURL().then(url => {
                  this.claim.attachanswer = url;
                  this.claim.attachboolanswer = true;
                });
              });
          }

          this.order.claims[this.claimid] = this.claim;
          await this.$db
            .collection("orders")
            .doc(this.orderid)
            .update({
              claims: this.order.claims
            })
            .then(() => {
              this.feedback(true);
              this.isSaveDisabled = false;
            })
            .catch(() => {
              this.feedback(false);
              this.isSaveDisabled = false;
            });
        } else {
          this.feedback(false);
          this.isSaveDisabled = false;
        }
      });
    },
    feedback(isPositive) {
      let message = isPositive
        ? this.$translate("success_form")
        : this.$translate("failed_form");
      let type = isPositive ? "is-success" : "is-danger";
      this.$buefy.notification.open({
        duration: 3000,
        message: message,
        type: type
      });
    }
    // async save() {
    //   this.claim.answer = true;
    //   this.claim.answertec = this.$store.getters.user.userInfo.username;
    //   this.claim.answercreationDate = new Date().getTime();

    //   this.order.claims[this.claimid] = this.claim;
    //   await this.$db
    //     .collection("orders")
    //     .doc(this.orderid)
    //     .set(
    //       {
    //         statusOrder: "segnreceiveord"
    //       },
    //       { merge: true }
    //     );

    //   await this.$db
    //     .collection("orders")
    //     .doc(this.orderid)
    //     .update({
    //       claims: this.order.claims
    //     })
    //     .then(() => {
    //       this.$router.push({ name: "orders" });
    //     });
    // },
    // validateBeforeSubmit() {
    //   this.$validator.validateAll().then(result => {
    //     if (result) {
    //       this.$buefy.notification.open({
    //         duration: 3000,
    //         message: this.$translate("success_form"),
    //         type: "is-success"
    //       });
    //       this.save();
    //       return;
    //     }
    //     this.$buefy.notification.open({
    //       duration: 3000,
    //       message: this.$translate("failed_form"),
    //       type: "is-danger"
    //     });
    //   });
    // }
  },
  async created() {
    this.isSaveDisabled = true;
    this.id = this.$route.params.id;
    this.orderid = this.$route.params.orderid;
    this.claimid = this.$route.params.claimid;
    if (this.orderid == null) {
      this.$router.push({ name: "orders" });
    }
    if (this.claimid == null) {
      this.$router.push({ name: "orders" });
    }

    if (this.id == -1) {
      this.title = "new_response";
    } else {
      this.title = "edit_response";
    }

    await this.$db
      .collection("orders")
      .doc(this.orderid)
      .get()
      .then(doc => {
        this.order = doc.data();
        this.claim = this.order.claims[this.claimid];
        this.isSaveDisabled = false;
      });
    // await this.$db
    //   .collection("patients")
    //   .doc(this.order.patientId)
    //   .get()
    //   .then(patientDoc => {
    //     this.order.patient = patientDoc.data();
    //   });
  }
};
</script>

<style></style>
